import React from 'react';

// Utilities
import bem from '../../../../../lib/bemUtils/bem';
import { Modifier } from '../../../../../lib/bemUtils/Modifier';

export enum FormsRowModifier {
  TWO_DATETIMES = '2datetimes',
  RIGHT = 'right',
  NO_MARGIN = 'no-margin',
}

type FormsRowProps = {
  modifier?: Modifier<FormsRowModifier>;
  children: React.ReactNode;
};

/** Row in a form that can be modified */
export default function FormsRow(props: FormsRowProps) {
  return <div className={bem('form-row', props.modifier)}>{props.children}</div>;
}
